document.addEventListener("click", function(e) {
  if (e.target.closest(".mobile-facets__close-clone")) {
    const closeBtn = document.querySelector(".mobile-facets__close");
    if (closeBtn) {
      closeBtn.click();
    }
  }
});

function updateFilterCount() {
  const wrapper = document.querySelector(".mobile-facets");
  if (!wrapper) return;
  // checkbox + radio
  const checkedInputs = wrapper.querySelectorAll(
    'input[type="checkbox"]:checked, input[type="radio"]:checked'
  ).length;
  // select dropdowns
  let selectCount = 0;
  wrapper.querySelectorAll("select").forEach(select => {
    if (select.value && select.value !== "") {
      selectCount++;
    }
  });
  const activeFilters = checkedInputs + selectCount;
  // get ALL apply buttons
  const applyBtns = wrapper.querySelectorAll(".mobile-filter-apply");
  if (!applyBtns.length) return;
  applyBtns.forEach(btn => {
    btn.textContent = activeFilters > 0
      ? `Apply (${activeFilters})`
      : "Apply";
  });
}
// run on page load
document.addEventListener("DOMContentLoaded", updateFilterCount);
// run when filters change
document.addEventListener("change", function (e) {
  if (e.target.closest(".mobile-facets")) {
    updateFilterCount();
  }
});

if(document.querySelectorAll(".section:last-child:has(.multicolumn.mc-card)").length) {
  document.querySelector(".footer-border-img").classList.add("has-merged-bg")
}
document.querySelectorAll('.collapsible-content').forEach((accordion) => {
  const items = accordion.querySelectorAll('details');

  items.forEach((detail) => {
    detail.addEventListener('toggle', function () {
      if (this.open) {
        items.forEach((other) => {
          if (other !== this) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });
});

(function () {
  function processInlineSvgs(root = document) {
    const inlineSvgTargets = root.querySelectorAll('[data-inline-svg]:not([data-inline-svg-loaded])');
    //console.log(inlineSvgTargets);

    inlineSvgTargets.forEach((el) => {
      const src = el.querySelector("img").getAttribute("src");
      if (!src) return;

      // Mark as loading so we never double-fetch this element
      el.setAttribute('data-inline-svg-loaded', 'true');

      fetch(src)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to load SVG');
          return response.text();
        })
        .then((svgText) => {
          el.innerHTML = svgText;
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  // 1) Initial page load
  document.addEventListener('DOMContentLoaded', () => {
      processInlineSvgs(document);
      // processCustomOptionsValue(document);
  });

  // 2) Expose a helper you can call manually after custom AJAX loads
  window.ShopifyInlineSvg = window.ShopifyInlineSvg || {};
  window.ShopifyInlineSvg.process = processInlineSvgs;

  // 3) Automatically handle dynamically inserted content via MutationObserver
  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          // If the added node itself is a target
          if (node.matches && node.matches('[data-inline-svg]')) {
            processInlineSvgs(node);
          } else if (node.querySelectorAll) {
            // Or if it contains any targets inside
            processInlineSvgs(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  // 4) Handle Shopify Theme Editor section events
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      processInlineSvgs(event.target);
    }
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target) {
      processInlineSvgs(event.target);
    }
  });
})();


// document.querySelectorAll('.swatch').forEach(function(el){
//   let hex = el.dataset.color;
//   if(!hex) return;
//   hex = hex.replace('#','');
//   let r = parseInt(hex.substring(0,2),16);
//   let g = parseInt(hex.substring(2,4),16);
//   let b = parseInt(hex.substring(4,6),16);
//   let rgb = `${r}, ${g}, ${b}`;
//   el.style.setProperty('--swatch-rgb', rgb);
// });

document.addEventListener("DOMContentLoaded", function () {
  const svg = document.querySelector(".mobile-facets__sort > label");
  const radioWrapper = document.querySelector(".mobile-facets__sort .select--radio");
  if (!svg || !radioWrapper) return;
  svg.addEventListener("click", function () {
    svg.classList.toggle("active");
    radioWrapper.classList.toggle("active");
  });

});

window.addEventListener("load", (event) => {
  const menuItems = document.querySelectorAll('.header__menu-item');
 
  const svgLines = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 65 6" fill="none" class="navVecLine"><path d="M2.5 1.68863C13.6765 1.9711 61.1075 -0.783756 47.1373 1.68855C37.5574 3.38389 39.3922 3.91542 51.5 3.53119C63.6078 3.14695 79.5 1.68855 96.5 1.68855" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-dasharray="114" stroke-dashoffset="114"></path></svg>`,
    
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 54 5" fill="none" class="navVecLine"><path d="M0.650146 2.76362C7.65015 1.47258 23.1501 -0.567263 19.1501 1.60168C14.1501 4.31287 11.1501 3.92556 25.1501 2.76362C39.1501 1.60168 63.1501 1.60183 73.1501 2.76362" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-dasharray="86" stroke-dashoffset="86"></path></svg>`,
    
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 50 5" fill="none" class="navVecLine"><path d="M1.5 2.47345C1.5 2.47345 11.3991 2.37239 18.1393 2.16173C28.123 1.8497 36.2049 -0.332062 31.4508 2.47361C25.1992 6.16303 37.8203 2.11852 47.1393 1.22656C52.467 0.716627 59.5 1.22686 59.5 1.22686" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-dasharray="86" stroke-dashoffset="86"></path></svg>`,
    
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 68 5" fill="none" class="navVecLine"><path d="M1 2.30735C11.2667 2.02003 16.6444 0.0109751 11.7556 2.59455C5.32672 5.99191 18.3056 2.2671 27.8889 1.44621C45 -0.0194807 67 2.59441 67 2.59441" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-dasharray="77" stroke-dashoffset="77"></path></svg>`,
    
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 45 5" fill="none" class="navVecLine"><path d="M1.00334 2.64266C11.4019 2.00487 29.0492 0.568794 23.7142 3.08654C16.9352 6.28578 33.519 2.15683 50.0159 2.47925" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-dasharray="58" stroke-dashoffset="58"></path></svg>`,
    
    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 40 5" fill="none" class="navVecLine"><path d="M1.00334 2.64266C11.4019 2.00487 29.0492 0.568794 23.7142 3.08654C16.9352 6.28578 33.519 2.15683 50.0159 2.47925" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-dasharray="58" stroke-dashoffset="58"></path></svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 60 5" fill="none" class="navVecLine"><path d="M0.650146 2.76362C7.65015 1.47258 23.1501 -0.567263 19.1501 1.60168C14.1501 4.31287 11.1501 3.92556 25.1501 2.76362C39.1501 1.60168 63.1501 1.60183 73.1501 2.76362" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-dasharray="86" stroke-dashoffset="86"></path></svg>`
  ];
  console.log(svgLines);
  menuItems.forEach((item, index) => {
    const svgIndex = index % svgLines.length;

    // Insert SVG inside menu item (you can change position)
    item.insertAdjacentHTML('beforeend', svgLines[svgIndex]);
  });
});


// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelector('body').classList.add('loaded');

//   const clouds = document.querySelectorAll('.about-hero-cloud-images svg g');

//   clouds.forEach((cloud) => {
//     const duration = Math.random() * 25 + 15;
//     const startY = Math.random() * 30 - 10;
//     const scale = Math.random() * 0.5 + 0.7;
//     cloud.style.transform = `translateX(0px) translateY(${startY}px) scale(${scale})`;
//     const delay = Math.random() * 10;
//     cloud.style.animation = `cloudMove ${duration}s linear infinite`;
//     cloud.style.animationDelay = `${delay}s`;
// });

//   const cloudsCommon = document.querySelectorAll('.common-hero-cloud-images svg g');
//   cloudsCommon.forEach((cloud) => {
//       const duration = Math.random() * 25 + 15;
//       const startY = Math.random() * 30 - 10;
//       const scale = Math.random() * 0.5 + 0.7;
//       cloud.style.transform = `translateX(0px) translateY(${startY}px) scale(${scale})`;
//       const delay = Math.random() * 10;
//       cloud.style.animation = `cloudMove ${duration}s linear infinite`;
//       cloud.style.animationDelay = `${delay}s`;
//   });

// });

// document.querySelectorAll('.header__search .header__icon--search')
//   .forEach(el => {
//     el.addEventListener('click', () => {
//       el.closest('details')?.setAttribute('open', 'true');
//     });
//   });

// document.addEventListener('scroll', function () {
//   const scrollTop = window.scrollY;
//   const speed = 0.3; // adjust speed

//   document.querySelectorAll('.wave-icon-wrap').forEach((svg, index) => {
//     svg.style.transform = `translateX(${scrollTop * speed * (index + 1)}px)`;
//   });
// });
const sections = document.querySelectorAll('.wave-border-anim');
sections.forEach((section) => {
  let isVisible = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isVisible = entry.isIntersecting;
    });
  }, {
    threshold: 0.1
  });

  observer.observe(section);

  document.addEventListener('scroll', function () {
    if (!isVisible) return;

    const rect = section.getBoundingClientRect();
    const offset = window.innerHeight - rect.top;
    const speed = 0.2;

    section.querySelectorAll('.wave-icon-wrap').forEach((el, index) => {
      el.style.transform = `translateX(${offset * speed * (index + 1)}px)`;
    });
  });
});


var logosSwiper = new Swiper(".tickers-section .swiper", {
  spaceBetween: 40,
  speed: 20000,
  slidesPerView: 'auto',
  loop: true,
  freeMode: true,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: false
  },
});

// Check 2nd group
document.querySelectorAll('fieldset.shopify_subscriptions_fieldset .plan_card .subscription_group:nth-of-type(2) input')
.forEach(input => {
  input.checked = true;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});


const fieldsets = document.querySelectorAll('fieldset.shopify_subscriptions_fieldset');
fieldsets.forEach(fieldset => {
  const group = fieldset.querySelector(
    '.plan_card .subscription_group:nth-of-type(2) .group_list'
  );
  if (!group) return;
  const liCount = group.querySelectorAll('li').length;
  if (liCount > 1) {
    fieldset.classList.add('more-subscription');
    fieldset.classList.remove('one-subscription');
  } else {
    fieldset.classList.add('one-subscription');
    fieldset.classList.remove('more-subscription');
  }
});


